var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRocket = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#rocket_svg__a)",
  stroke: "#0F172A"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6.033 12.958.05-.05.042-.058a.08.08 0 0 1 .007-.01c.191-.115.388-.293.499-.571.097-.243.093-.48.077-.647A20.573 20.573 0 0 1 9.745 1.386l.008-.013.008-.014a.246.246 0 0 1 .434.008l.016.031.018.03a19.24 19.24 0 0 1 2.274 5.131l.003.01c.508 1.74.782 3.54.816 5.352.001.29.116.569.32.776l.041.04.046.035a2.69 2.69 0 0 1 1.065 2.128v3.332a45.542 45.542 0 0 0-1.377-1.816 3.126 3.126 0 0 0-2.621-1.208H9.173a3.392 3.392 0 0 0-2.806 1.467l-1.216 1.616-.007-3.3a2.99 2.99 0 0 1 .889-2.033Zm8.78 6.273v-.002.002Z",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9.998,
  cy: 8.648,
  r: 0.8,
  strokeWidth: 1.341
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "rocket_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgRocket;